import React from 'react';
import PropTypes from 'prop-types';

class Item extends React.Component {
  displayComponent = () => {
    const {
      name,
      children,
      isActive,
      image,
    } = this.props;


    // Dropdown

    return (
      <li
        className={`bgDropdown ${isActive ? 'active' : ''} `}
        onClick={e => this.props.onClick(e)}
        onKeyDown={() => {}}
        role="presentation"
      >
        { image && <img src={image} alt="bg" />}
        { name }
        { children }
      </li>
    );
  }

  render() {
    return (
      this.displayComponent()
    );
  }
}

Item.defaultProps = {
  name: '',
  isActive: false,
};

Item.propTypes = {
  name: PropTypes.string,
  isActive: PropTypes.bool,
};

export default Item;



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/colors/page-background-color/Item.jsx